import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CheckIfClassCompleted from '../../../../components/CheckIfClassCompleted';
import FavoriteButton from '../../../../components/FavoriteButton';
import Scheduling from '../../../../components/Scheduling';
import time from '../../../../assets/icons/time@2x.png';
import calendar from '../../../../assets/icons/calendar@2x.png';

import {
  Container,
  Thumbnail,
  Informations,
  TitleContainer,
  Description,
  Options,
  ContainerCheckedIconDesktop,
  MenuMobile,
} from './styles';
import Audio from '../../../../components/Audio';

const Class = ({
  item,
  pathname,
  setShowLoadModal,
  setShowNoAccessModal,
  checkIfUserHasAnActivePlan,
}) => {
  const user = useSelector((state) => state.User);
  const history = useHistory();
  const [showSchedulingComponent, setShowSchedulingComponent] = useState(false);

  const handleSchedule = async () => {
    if (!user.id.trim() || !user.accessToken.trim()) {
      setShowLoadModal(false);
      setShowNoAccessModal(true);
      return;
    }

    setShowLoadModal(true);

    const userHasAccess = await checkIfUserHasAnActivePlan();

    setShowLoadModal(false);

    if (userHasAccess) {
      setShowSchedulingComponent(true);
    } else {
      setShowNoAccessModal(true);
    }
  };

  function renderAssistedClassIcon() {
    return (
      <ContainerCheckedIconDesktop style={{ marginTop: '0.375rem' }}>
        <CheckIfClassCompleted
          completed={item.is_completed}
          post_id={item.post_id}
          setShowLoadModal={setShowLoadModal}
        />
      </ContainerCheckedIconDesktop>
    );
  }

  function renderDuration() {
    const { duration } = item;
    if (duration > 0) {
      if (duration < 60) {
        return (
          <div>
            <img src={time} alt="Ícone de tempo da aula" />
            <span>{duration} min</span>
          </div>
        );
      } else {
        const hours = Math.trunc(duration / 60);
        const minutes = Math.trunc(duration - 60 * hours);
        return (
          <div>
            <img src={time} alt="Ícone de tempo da aula" />
            <span>
              {hours} {hours === 1 ? 'hora' : 'horas'}
              {minutes > 0 && ` e ${minutes} minutos`}
            </span>
          </div>
        );
      }
    }
  }

  const handleCard = () => {
    if (pathname.includes('podcast')) {
      history.push({
        pathname: `/podcast/aula/${item.id}`,
      });
    } else if (pathname.includes('meditacao')) {
      history.push({
        pathname: `/meditacao/aula/${item.id}`,
      });
    } else {
      history.push({
        pathname: `/aula/${item.id}`,
      });
    }
  };

  function renderSchedulingComponent() {
    if (showSchedulingComponent) {
      return (
        <Scheduling
          type="aula"
          show={showSchedulingComponent}
          setShow={setShowSchedulingComponent}
          postId={item.post_id}
        />
      );
    }
  }

  return (
    <Container>
      <div>
        <Thumbnail
          onClick={() => handleCard()}
          src={item.thumbnail_url}
          alt="Thumbnail da aula"
        />
        <div>
          {renderAssistedClassIcon()}
          <Informations>
            <TitleContainer onClick={() => handleCard()}>
              <div>{item.name}</div>
            </TitleContainer>
            {item.audio_url ? (
              <Audio
                id="podcast-audio"
                controls
                controlsList="nodownload"
                preload="metadata"
                src={item.audio_url}
              ></Audio>
            ) : null}
            <MenuMobile>
              <CheckIfClassCompleted
                completed={item.is_completed}
                post_id={item.post_id}
                setShowLoadModal={setShowLoadModal}
              />
              <FavoriteButton
                post_id={item.post_id}
                is_favorite={item.is_favorite}
                favorite_id={item.favorite_id}
                setShowLoadModal={setShowLoadModal}
              />
              <img src={calendar} onClick={() => handleSchedule()} />
            </MenuMobile>
            <Description>
              {renderDuration()}
              <p>{item.description}</p>
            </Description>
          </Informations>
        </div>
      </div>
      <Options>
        <FavoriteButton
          post_id={item.post_id}
          is_favorite={item.is_favorite}
          favorite_id={item.favorite_id}
          setShowLoadModal={setShowLoadModal}
        />
        <img src={calendar} onClick={() => handleSchedule()} />
      </Options>
      {renderSchedulingComponent()}
    </Container>
  );
};

export default Class;
